export function cableHasResult (value, resultValue) {
  let hasResult = false
  const materialsSourceReport = resultValue.materialsSourceReport

  // Должен быть хотя бы 1 участок, в каждом хотя бы 1 сегмент, и у каждого сегмента должен быть указан id монтажа или демонтажа
  const reportValue = value && materialsSourceReport ? value[materialsSourceReport.key] : null // участки
  if (reportValue && reportValue.length) {
    hasResult = true
    for (let i = 0; i < reportValue.length; i++) {
      const segments = reportValue[i] // участок
      if (!segments || segments.length === 0 || segments.find(segment => !segment.mountingId && !segment.demountingId) != null) {
        hasResult = false
        break
      }
    }
  }

  return hasResult
}
